import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconReserveItem = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 2.9502V11.4001L7.49994 14.0001V6.20016" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M1.49193 2.47564C1.29614 2.5409 1.16057 2.71974 1.15062 2.92587C1.14067 3.132 1.25839 3.32307 1.44697 3.40689L7.29692 6.00686C7.4262 6.06432 7.57377 6.06432 7.70305 6.00686L13.553 3.40689C13.7416 3.32307 13.8593 3.132 13.8493 2.92587C13.8394 2.71974 13.7038 2.5409 13.508 2.47564L7.6581 0.525658C7.55547 0.491447 7.4445 0.491447 7.34187 0.525658L1.49193 2.47564Z" stroke={color} strokeLinejoin="round" />
            <path d="M13.9999 2.9502V5.55017" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.3235 13.1474C10.5705 13.0239 10.6706 12.7236 10.5471 12.4766C10.4236 12.2296 10.1232 12.1295 9.87625 12.253L10.3235 13.1474ZM7.72349 14.4474L10.3235 13.1474L9.87625 12.253L7.27628 13.553L7.72349 14.4474Z" fill={color} />
            <circle cx="13.9999" cy="10.0997" r="3.39996" stroke={color} strokeLinejoin="round" />
            <path d="M12.6998 9.95535L13.6283 11.3998L15.2997 8.7998" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </div>
);

export default IconReserveItem;
